'use client';

import { useEffect } from 'react';

import { useCommonRouter } from '../components/RouterProvider';
import { addBznavMessageListener, removeBznavMessageListener } from '../utils/react-native-bridge';

export const useBznavAppPageNavigation = () => {
  const router = useCommonRouter();

  useEffect(() => {
    const pageNavigationHandler = (messageData: unknown) => {
      if (!messageData || typeof messageData !== 'object') {
        console.warn('Received pageNavigation message with invalid data:', messageData);
        return;
      }
      const { path, mode = 'push' } = messageData as { path: string; mode?: 'push' | 'replace' };
      if (typeof path === 'string') {
        if (mode === 'replace') {
          router.replace(path);
          return;
        }
        router.push(path);
      } else {
        console.warn('Received pageNavigation message with invalid path:', messageData);
      }
    };
    addBznavMessageListener('pageNavigation', pageNavigationHandler);

    return () => {
      removeBznavMessageListener('pageNavigation', pageNavigationHandler);
    };
  }, [router]);
};
